import { Box, Tooltip, Typography } from "@mui/material";
import Fade from "@mui/material/Fade";
import { useState, useRef, useEffect } from "react";
import { styles } from "./styles";
import { useTranslation } from "react-i18next";

const CustomTooltipBox = (props) => {
  const { sections } = props;
  const [open, setOpen] = useState(false);
  const tooltipRef = useRef(null);
  const iconRef = useRef(null);

  const { t } = useTranslation("custom-tooltip-box");

  const handleToggle = (e) => {
    e.stopPropagation();
    setOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!open) return;

      const tooltipEl = tooltipRef.current;
      const iconEl = iconRef.current;

      if (tooltipEl && tooltipEl.contains(e.target)) return;
      if (iconEl && iconEl.contains(e.target)) return;

      setOpen(false);
    };

    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, [open]);

  const renderTooltipContent = () => (
    <Box
      ref={tooltipRef}
      className="custom-scrollbar"
      sx={styles.tooltipContainer}
      onClick={(e) => e.stopPropagation()}
    >
      <Typography sx={styles.tooltipTitle}>{t("need_help")}</Typography>

      {sections?.length > 0 &&
        sections.map((section, idx) => {
          const { title, description } = section;

          return (
            <Box key={idx} sx={styles.sectionWrapper}>
              <Typography sx={styles.sectionTitle}>{title}</Typography>

              <Typography sx={styles.sectionDescription}>
                {description}
              </Typography>

              {/* <Box sx={styles.moreInfoWrapper}>
                <Typography sx={styles.moreInfoText}>
                  {t("more_info")}
                </Typography>

                <img
                  src="/icons/external-link-bold-icon.svg"
                  alt="external-link-icon"
                  style={styles.moreInfoIcon}
                />
              </Box> */}
            </Box>
          );
        })}
    </Box>
  );

  return (
    <Tooltip
      open={open}
      disableHoverListener
      disableFocusListener
      disableTouchListener
      title={renderTooltipContent()}
      arrow
      placement="bottom"
      slots={{ transition: Fade }}
      slotProps={{
        popper: { sx: styles.tooltipPopper },
        tooltip: { sx: styles.tooltipBox },
        arrow: { sx: styles.tooltipArrow },
      }}
    >
      <div
        ref={iconRef}
        onClick={handleToggle}
        style={styles.iconBase(open)}
      ></div>
    </Tooltip>
  );
};

export default CustomTooltipBox;
